const clear = (cmd: string, setHistory: React.Dispatch<React.SetStateAction<string[]>>): string[] => {
    setHistory([]); // Clears the terminal history
    return []; // Return an empty array since the terminal is now clear
  };
  
  export default clear;